module.exports = __webpack_public_path__ + "img/fruit-apricots-190x100.02708fea.jpg";